/**
 * StandardFaction enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file StandardFaction.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum StandardFaction {
  INVALID    = -1,
  HOSTILE_1    = 1,
  FRIENDLY_1   = 2,
  HOSTILE_2    = 3,
  FRIENDLY_2   = 4,
  NEUTRAL    = 5,
  INSANE     = 6,
  PTAT_TUSKAN  = 7,
  GLB_XOR    = 8,
  SURRENDER_1  = 9,
  SURRENDER_2  = 10,
  PREDATOR     = 11,
  PREY       = 12,
  TRAP       = 13,
  ENDAR_SPIRE  = 14,
  RANCOR     = 15,
  GIZKA_1    = 16,
  GIZKA_2    = 17,
}